export default "__VITE_ASSET__a67875cf__"